import React from 'react';
import { Row, Col, FormGroup, Card } from 'react-bootstrap';
import { set } from 'lodash';

import { ElementTemplate } from '../../../../DevlopmentOrder/PurchaseOrder/TemplateComponent';
import { usePOrderDetailState } from '../PODetailProvider';
import { commonPath } from '../../../../DevlopmentOrder/PurchaseOrder/fieldPath';

function RenderSupplierFactory({ data, pIndex }) {
  const { poDetailstate, setPoDetailState, supplierAddress, disablePoCondition } = usePOrderDetailState();
  const handleChange = async (value, keyName) => {
    const copyState = poDetailstate;
    let locate = '';
    if (keyName.includes('options')) {
      locate = keyName.split('.options');
    } else {
      locate = keyName.split('.value');
    }
    set(poDetailstate, `${locate[0]}.hasError.status`, false);
    await set(poDetailstate, keyName, value);
    await setPoDetailState((prevState) => ({
      ...prevState,
      ...copyState,
    }));
  };

  const bindDropDownFields = async (values, fieldName) => {
    setPoDetailState((prevState) => {
      const copyState = { ...prevState };
      const updatedColumns = copyState?.templateJsonSchema[pIndex]?.columns.map((column) =>
        column.map((col) => {
          if (col?.field === fieldName) {
            col.value = values;
            col.hasError = false;
          }
          if (
            (fieldName === 'contactPersonsDetails' && col.field === 'supplierContactEmail') ||
            (fieldName === 'factContactPersonsDetails' && col.field === 'factoryContactEmail')
          ) {
            col.value = values ? values.email : col.value;
            col.hasError = false;
          }
          return col;
        }),
      );

      copyState.templateJsonSchema[pIndex].columns = updatedColumns;
      return { ...copyState };
    });
  };

  const bindFactoryDetails = async (values) => {
    setPoDetailState((prevState) => {
      const copyState = { ...prevState };
      const updatedColumns = copyState?.templateJsonSchema[pIndex]?.columns.map((column) =>
        column.map((col) => {
          if (col.hasError) {
            col.hasError.status = false;
          }
          switch (col.field) {
            case 'factoryName':
              col.value = values;
              break;
            case 'factoryAddress':
              col.value = supplierAddress(values).join('\n');
              break;
            case 'factoryCode':
              col.value = values.factoryCode || '';
              break;
            case 'factContactPersonsDetails':
              col.options = values.contactPersons || [];
              col.value = col.value && col.options.map((val) => val._id).includes(col.value._id) && col.value;
              break;
            case 'factoryContactEmail':
              col.value = '';
              break;
            default:
              break;
          }
          return col;
        }),
      );

      copyState.templateJsonSchema[pIndex].columns = updatedColumns;
      return { ...copyState };
    });
  };

  const handleDropDown = async (value, fieldName) => {
    switch (fieldName) {
      case 'factoryName':
        await bindFactoryDetails(value);
        break;
      case 'factContactPersonsDetails':
      case 'contactPersonsDetails':
        await bindDropDownFields(value, fieldName);
        break;
      default:
        break;
    }
  };
  return (
    <Card className="listing-card">
      <Card.Header className="px-2 py-2">
        <strong>{data?.label}</strong>
      </Card.Header>
      <Card.Body className="py-4">
        <Row className="span_font_size">
          {data?.columns.map((column, index) => {
            return (
              <Col lg={6} key={index}>
                {column.map((col, i) => {
                  return (
                    col?.enable && (
                      <FormGroup key={col?.key}>
                        <ElementTemplate
                          {...col}
                          keys={col?.key}
                          onChange={(value, path) => {
                            if (['factoryName', 'factContactPersonsDetails', 'contactPersonsDetails'].includes(col?.field)) {
                              handleDropDown(value, col?.field);
                            } else {
                              handleChange(value, path);
                            }
                          }}
                          error={col?.hasError}
                          requiredField={col?.required}
                          value={col?.value}
                          disable={disablePoCondition}
                          path={
                            col?.key === 'Check_Boxes' ? commonPath(pIndex, index, i).COMPANY_DETAILS_CHECKBOX : commonPath(pIndex, index, i).COMPANY_DETAILS
                          }
                        />
                      </FormGroup>
                    )
                  );
                })}
              </Col>
            );
          })}
        </Row>
      </Card.Body>
    </Card>
  );
}

export default RenderSupplierFactory;
